var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 786.714,
    height: 727.778,
    viewBox: "0 0 786.714 727.778",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-247.83 -75.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321-414",
    "data-name": "Path 1321",
    d: "M939.7,235.558h-4V126.013a63.4,63.4,0,0,0-63.4-63.4H640.213a63.4,63.4,0,0,0-63.4,63.4V726.987a63.4,63.4,0,0,0,63.4,63.4H872.3a63.4,63.4,0,0,0,63.4-63.4V313.534h4Z",
    transform: "translate(-158.255 13)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322-415",
    "data-name": "Path 1322",
    d: "M874.858,79.106H844.563A22.495,22.495,0,0,1,823.735,110.1H690.776a22.495,22.495,0,0,1-20.827-30.991h-28.3a47.348,47.348,0,0,0-47.348,47.348V726.546a47.348,47.348,0,0,0,47.348,47.348h233.2a47.348,47.348,0,0,0,47.348-47.348h0V126.454a47.348,47.348,0,0,0-47.348-47.348Z",
    transform: "translate(-158.255 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-416",
    "data-name": "Path 39",
    d: "M902.962,550.43H623.343a5.184,5.184,0,0,1-5.178-5.178V475.891a5.184,5.184,0,0,1,5.178-5.178H902.962a5.184,5.184,0,0,1,5.178,5.178v69.362A5.184,5.184,0,0,1,902.962,550.43ZM623.343,472.784a3.11,3.11,0,0,0-3.107,3.107v69.362a3.11,3.11,0,0,0,3.107,3.107H902.962a3.11,3.11,0,0,0,3.107-3.107V475.891a3.11,3.11,0,0,0-3.107-3.107Z",
    transform: "translate(-158.255 13)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 21.748,
    cy: 21.748,
    r: 21.748,
    transform: "translate(479.586 501.822)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-417",
    "data-name": "Path 40",
    d: "M709.817,496.073a3.625,3.625,0,1,0,0,7.249H880.7a3.625,3.625,0,1,0,.119-7.249h-171Z",
    transform: "translate(-158.255 13)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-418",
    "data-name": "Path 41",
    d: "M709.817,517.821a3.625,3.625,0,1,0,0,7.25H880.7a3.625,3.625,0,1,0,.119-7.249h-171Z",
    transform: "translate(-158.255 13)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-419",
    "data-name": "Path 42",
    d: "M902.962,666.42H623.343a5.184,5.184,0,0,1-5.178-5.178V591.881a5.184,5.184,0,0,1,5.178-5.178H902.962a5.184,5.184,0,0,1,5.178,5.178v69.362a5.184,5.184,0,0,1-5.178,5.177ZM623.343,588.774a3.11,3.11,0,0,0-3.107,3.107v69.362a3.11,3.11,0,0,0,3.107,3.107H902.962a3.11,3.11,0,0,0,3.107-3.107V591.881a3.11,3.11,0,0,0-3.107-3.107Z",
    transform: "translate(-158.255 13)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 21.748,
    cy: 21.748,
    r: 21.748,
    transform: "translate(479.586 617.813)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-420",
    "data-name": "Path 43",
    d: "M709.817,612.063a3.625,3.625,0,1,0,0,7.25H880.7a3.625,3.625,0,1,0,.119-7.249h-171Z",
    transform: "translate(-158.255 13)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-421",
    "data-name": "Path 44",
    d: "M709.817,633.811a3.625,3.625,0,1,0,0,7.25H880.7a3.625,3.625,0,1,0,.119-7.249h-171Z",
    transform: "translate(-158.255 13)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-422",
    "data-name": "Path 45",
    d: "M757.268,406.495a98.343,98.343,0,0,1-98.384-98.3v-.082c0-.206,0-.423.012-.629.3-53.879,44.432-97.756,98.372-97.756a98.384,98.384,0,1,1,.011,196.768h-.011Zm0-194.7a96.519,96.519,0,0,0-96.3,95.749c-.011.22-.011.4-.011.564a96.325,96.325,0,1,0,96.325-96.313Z",
    transform: "translate(-158.255 13)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711-423",
    "data-name": "Path 711",
    d: "M678.036,584.1H578.423a2.029,2.029,0,0,1-.372-.03l47.112-81.6a3.3,3.3,0,0,1,5.742,0l31.618,54.763,1.515,2.62Z",
    transform: "translate(-28.044 -221.332)",
    fill: "#5165fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265-424",
    "data-name": "Path 1265",
    d: "M395.632,593.142a14.257,14.257,0,0,1-.289,2.868,21.322,21.322,0,0,1-16.65,0,14.262,14.262,0,0,1-.289-2.868c0-5.006,2.549-9.237,6.06-10.651a6.587,6.587,0,1,1,5.107,0C393.083,583.905,395.632,588.136,395.632,593.142Z",
    transform: "translate(490.489 -361.041)",
    fill: "#5165fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362-425",
    "data-name": "Path 1362",
    d: "M517.266,138.016l82.121,82.769h38.77v1.3H598.844l-.191-.193-82.312-82.963Z",
    transform: "translate(-193.821 308.484)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2-426",
    "data-name": "Path 45",
    d: "M694.141,280.24a35.242,35.242,0,0,1-35.257-35.228v-.029c0-.074,0-.152,0-.225a35.257,35.257,0,1,1,35.257,35.482h0Zm0-69.773a34.589,34.589,0,0,0-34.51,34.313c0,.079,0,.143,0,.2a34.519,34.519,0,1,0,34.519-34.515Z",
    transform: "translate(-397.884 181.512)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363-427",
    "data-name": "Path 1363",
    d: "M517.266,138.016l82.121,82.769h38.77v1.3H598.844l-.191-.193-82.312-82.962Z",
    transform: "translate(-193.821 431.666)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-3-428",
    "data-name": "Path 45",
    d: "M694.141,209.726a35.242,35.242,0,0,0-35.257,35.228v.029c0,.074,0,.152,0,.225a35.257,35.257,0,1,0,35.257-35.482h0Zm0,69.773a34.589,34.589,0,0,1-34.51-34.313c0-.079,0-.143,0-.2A34.519,34.519,0,1,1,694.146,279.5Z",
    transform: "translate(-397.884 303.775)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 18.746,
    height: 3.758,
    transform: "translate(307.185 423.994) rotate(90)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 32.493,
    height: 3.758,
    transform: "translate(298.138 410.25) rotate(90)",
    fill: "#5165fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 24.397,
    height: 3.758,
    transform: "translate(289.091 418.346) rotate(90)",
    fill: "#5165fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 3.936,
    cy: 3.936,
    r: 3.936,
    transform: "translate(281.209 544.822)",
    fill: "#5165fb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 3.936,
    cy: 3.936,
    r: 3.936,
    transform: "translate(303.437 544.822)",
    fill: "#5165fb",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 329.877, 386.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1341-429",
    "data-name": "Path 1341",
    d: "M406.822,411.073a1.377,1.377,0,0,0-1.375,1.375v16.046a1.377,1.377,0,0,0,1.375,1.375h27.966a1.377,1.377,0,0,0,1.375-1.375V412.448a1.377,1.377,0,0,0-1.375-1.375Z",
    transform: "translate(0.7 0.389)",
    fill: "#5165fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342-430",
    "data-name": "Path 1342",
    d: "M435.439,422.174H413.432a.458.458,0,1,1,0-.917h22.006a.458.458,0,0,1,0,.917Z",
    transform: "translate(-2.93 -4.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343-431",
    "data-name": "Path 1343",
    d: "M435.439,429.259H413.432a.458.458,0,1,1,0-.917h22.006a.458.458,0,1,1,0,.917Z",
    transform: "translate(-2.93 -7.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344-432",
    "data-name": "Path 1344",
    d: "M435.439,436.343H413.433a.458.458,0,1,1,0-.917h22.006a.458.458,0,0,1,0,.917Z",
    transform: "translate(-2.93 -11.357)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 3.936,
    cy: 3.936,
    r: 3.936,
    transform: "translate(292.323 544.822)",
    fill: "#5165fb",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(295.67 125.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375-433",
    "data-name": "Path 1375",
    d: "M295.905,535.2a9.138,9.138,0,0,1,5.678-12.81l1.757-32.425L316.9,500l-3.748,29.253a9.187,9.187,0,0,1-17.251,5.944Z",
    transform: "translate(415.135 -72.141)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376-434",
    "data-name": "Path 1376",
    d: "M436.142,541.231a9.138,9.138,0,0,0-3.636-13.532l3.263-32.308-14.949,7.827-.807,29.481a9.187,9.187,0,0,0,16.129,8.532Z",
    transform: "translate(169.818 -72.141)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377-435",
    "data-name": "Path 1377",
    d: "M225.135,591.715h-10.68l-5.082-41.2h15.764Z",
    transform: "translate(460.604 76)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378-436",
    "data-name": "Path 1378",
    d: "M372.985,736.368H351.95a13.405,13.405,0,0,0-13.4,13.4v.436h34.439Z",
    transform: "translate(315.479 -72.141)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379-437",
    "data-name": "Path 1379",
    d: "M287.364,585.3l-10.444,2.238-13.6-39.219,15.414-3.3Z",
    transform: "translate(344.431 76)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380-438",
    "data-name": "Path 1380",
    d: "M421.548,729.46l-20.568,4.407h0a13.405,13.405,0,0,0-10.3,15.916l.091.426,33.675-7.215Z",
    transform: "translate(212.181 -72.141)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381-439",
    "data-name": "Path 1381",
    d: "M437.648,504.094s11.363,35.119.235,74.833L426.556,626.5l-2.811,105.263L400.808,724.4l-9.345-160.557L348.422,636.9l22.654,87.5-26.052.849-28.132-94.627,24.734-88.3,4.531-21.521Z",
    transform: "translate(267.349 -72.141)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382-440",
    "data-name": "Path 1382",
    d: "M330.288,387.463l22.814-13,39.468-2.281,27.377,14.373L408.821,462.88s21.22,30.454,13.483,50.745c-9.549,25.044-93.046,38.109-91.413,13.668,2.577-38.57,6.558-35.91,9.476-54.824,3.2-20.753-19.206-47.363-19.206-47.363Z",
    transform: "translate(281.846 -72.141)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383-441",
    "data-name": "Path 1383",
    d: "M288.136,394.079l2.543-11.022s10.849,1.4,18.368,22.405,20.884,65.272,20.884,65.272l-.7,16.083s5.151,5.951,1.6,8.669,6.419,6.4,1.369,10.266a14.493,14.493,0,0,0-5.293,14.829l-15.514-4.791,1.141-25.324-6.146-19.962-16.426-49.963Z",
    transform: "translate(405.216 -72.141)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384-442",
    "data-name": "Path 1384",
    d: "M442.4,395.958l-3.456-10.689s-6.364-2.6-11.062,12.072-6.928,51.815-6.928,51.815l-9.126,44.27s-3.41,5.638-1.6,7.254-7.963,3.888-2.281,6.882-.49-.645,1.633,6.181c1.394,4.483-.036,6.839-.036,6.839l17.567-3.534,4.791-22.693,10.867-42.191Z",
    transform: "translate(178.091 -72.141)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 30.298,
    cy: 30.298,
    rx: 30.298,
    ry: 30.298,
    transform: "translate(624.298 229.844)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385-443",
    "data-name": "Path 1385",
    d: "M294.261,313.427a63.528,63.528,0,0,1,23.113-14.946c5.587-2.07,11.668-3.349,17.509-2.173s11.365,5.216,12.995,10.947c1.332,4.686-.043,9.732-2.111,14.144s-4.829,8.5-6.5,13.078A29.85,29.85,0,0,0,369.3,374.505c-5.739.77-11.03,3.467-16.639,4.9s-12.231,1.338-16.4-2.681c-4.411-4.252-4.5-11.166-4.286-17.289l.951-27.306c.162-4.642.3-9.432-1.374-13.765s-5.652-8.126-10.3-8.087c-3.52.03-6.636,2.162-9.458,4.265s-5.811,4.347-9.317,4.659-7.509-2.282-7.247-5.792Z",
    transform: "translate(363.447 -72.141)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    cx: 22.302,
    cy: 22.302,
    rx: 22.302,
    ry: 22.302,
    transform: "translate(642.678 301.545) rotate(-118.663)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386-444",
    "data-name": "Path 1386",
    d: "M354.16,341.731h32.2l.33-4.624,1.651,4.624H393.3l.654-9.164,3.273,9.164h9.6v-.454a24.09,24.09,0,0,0-24.063-24.063h-4.54a24.09,24.09,0,0,0-24.063,24.063Z",
    transform: "translate(266.023 -72.141)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387-445",
    "data-name": "Path 1387",
    d: "M357.5,358.351l11.76-11.773,1.983-26.061H345.282l.643.642C354.867,330.089,364.52,343.194,357.5,358.351Z",
    transform: "translate(310.486 -72.141)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_944-446",
    "data-name": "Path 944",
    d: "M1006.459,659.044H237.982a1,1,0,1,1,0-2h768.477a1,1,0,1,1,0,2Z",
    transform: "translate(10.882 144.346)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(324.445 741.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438-447",
    "data-name": "Path 438",
    d: "M264.378,626.53a12.8,12.8,0,0,0,12.364-2.178c4.33-3.635,5.688-9.623,6.793-15.168l3.268-16.4-6.841,4.711c-4.92,3.388-9.95,6.884-13.356,11.79s-4.893,11.6-2.156,16.914",
    transform: "translate(-262.92 -592.784)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439-448",
    "data-name": "Path 439",
    d: "M266.983,697.106c-.861-6.273-1.747-12.627-1.143-18.967a29.832,29.832,0,0,1,5.752-15.64,26.018,26.018,0,0,1,6.675-6.049c.668-.421,1.282.637.617,1.056a24.735,24.735,0,0,0-9.784,11.805c-2.13,5.418-2.472,11.324-2.105,17.079.222,3.48.692,6.938,1.167,10.391a.634.634,0,0,1-.427.752.615.615,0,0,1-.752-.427Z",
    transform: "translate(-264.469 -642.364)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442-449",
    "data-name": "Path 442",
    d: "M289.28,708.161a9.425,9.425,0,0,0,8.212,4.238c4.157-.2,7.623-3.1,10.743-5.853l9.228-8.147-6.107-.292c-4.392-.21-8.9-.406-13.08.948s-8.041,4.614-8.806,8.944",
    transform: "translate(-280.568 -663.484)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443-450",
    "data-name": "Path 443",
    d: "M262.845,737.661c4.145-7.335,8.953-15.486,17.544-18.092a19.578,19.578,0,0,1,7.379-.762c.783.068.588,1.275-.194,1.208a18.188,18.188,0,0,0-11.776,3.116,30.61,30.61,0,0,0-8.094,8.735c-1.34,2.041-2.541,4.169-3.742,6.294C263.579,738.839,262.457,738.349,262.845,737.661Z",
    transform: "translate(-262.765 -679.313)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-4-451",
    "data-name": "Path 45",
    d: "M694.141,280.24a35.242,35.242,0,0,1-35.257-35.228v-.029c0-.074,0-.152,0-.225a35.257,35.257,0,1,1,35.257,35.482h0Zm0-69.773a34.589,34.589,0,0,0-34.51,34.313c0,.079,0,.143,0,.2a34.519,34.519,0,1,0,34.519-34.515Z",
    transform: "translate(183.469 -22.258)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414-452",
    "data-name": "Path 1414",
    d: "M637.231,138.016l-82.121,82.769h-38.77v1.3h39.313l.191-.193,82.312-82.962Z",
    transform: "translate(204.196 99.023)",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationApp);
export default __webpack_public_path__ + "static/media/illustration_app.5d65df47f627f8b536b4728a2f0fc2cc.svg";
export { ForwardRef as ReactComponent };